var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-18",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.92,164.89l.33,2,.38,2.09c.28,1.39.54,2.79.86,4.17.61,2.78,1.31,5.52,2.11,8.17.4,1.32.84,2.63,1.31,3.89s1,2.52,1.49,3.7a30.56,30.56,0,0,0,3.67,6.23l-2.74-1.8a3.93,3.93,0,0,0,2.29.53,10.17,10.17,0,0,0,3.74-1.1,27.39,27.39,0,0,0,4.29-2.66c.72-.53,1.45-1.09,2.15-1.69.36-.29.71-.59,1-.89s.73-.64,1-.85l.53-.43a3.72,3.72,0,0,1,5.7,4.47c-.3.63-.5,1.11-.77,1.63s-.53,1-.81,1.5c-.58,1-1.19,1.95-1.87,2.89a29.71,29.71,0,0,1-4.86,5.31,22.39,22.39,0,0,1-3.23,2.28,17.69,17.69,0,0,1-8.72,2.51,17.06,17.06,0,0,1-5-.72,5.34,5.34,0,0,1-2.35-1.4l-.38-.39a39.4,39.4,0,0,1-6.5-9A64.13,64.13,0,0,1,159.5,186a86.24,86.24,0,0,1-2.77-9.5c-.36-1.59-.71-3.19-1-4.8-.14-.81-.28-1.61-.4-2.43s-.22-1.59-.32-2.58a7.5,7.5,0,0,1,14.84-2.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,186.08c-2.11.67-4.59,3.11-3.81,6s9.33,5,9.61-.14C195,187,191.67,186.08,191.67,186.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,188.87l.91-1.39L200.8,185s1.36,5.95-5.39,8.21A1.88,1.88,0,0,1,194,193l-2.69-1.4A1.94,1.94,0,0,1,190.54,188.87Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.08,154.75c11.94-2.17,28.12-2.58,39.85-.57a11.63,11.63,0,0,1,9.64,12.46c-.67,7.71-1.52,14.52-2,19.86.53,13.56-.62,36.22-.62,41l-49.69.7c-2.21-6.19-1.48-34.08-5.36-62.15A10,10,0,0,1,120.08,154.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.59,227.52l-1-.13c2.82-22.25,0-59.53,0-59.9l1-.08C145.62,167.79,148.43,205.17,145.59,227.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,155.32c-2-.53-.19-2.55-.19-2.55a96.32,96.32,0,0,1,15,1.21c.94.72-.08,1.65-.08,1.65S155.92,156.9,150.1,155.32Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,152.47s3,5.92-1,11.3a12.32,12.32,0,0,1,6,2s1.41-5.07-2.56-12.79C149.3,152.25,147.29,152.47,147.29,152.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,155.34c.77,3.61-5.94,10.43-5.94,10.43s-11.86-6.22-12.61-9.79Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,172.37c1.3,2.51-.28,13-5,18.23-.31-4.58-.7-9.37-1.2-14.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,136.82l13.44,6.44c-1.42,3.81-2.1,7.77,1.88,9.66a4.48,4.48,0,0,1,1.94,6.26,7.8,7.8,0,0,1-6.11,3.89c-4.67.47-9.27-2.53-11.95-5.34-1.1-1.16,0-2.52.12-4.14C133,147.87,133.88,141.88,133.16,136.82Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,138.1l7.25,5.16a18.22,18.22,0,0,0-.95,3.27c-3,1-7.7-1.62-7.78-4.22C137.83,141,139,138.72,139.35,138.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.77,115.09c2.57,2.09,5.5,11.43,1.73,15.2C144.94,123.83,144.31,114.12,148.77,115.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,125.9c1,8,1.2,12.7,5.52,16.51,6.49,5.73,16.14,1.32,17.53-6.81,1.25-7.33-.62-19.13-8.67-21.74A11.07,11.07,0,0,0,129.44,125.9Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69,132.78c3.78.28,5.09-8.86,2.74-14,1.64.68,6.31,0,7.61-2.13,7.54,2.14,10.36,2.18,11.32-.93s-10.89-5.85-17.75-4.38-4.84,6.44-4.84,6.44S117.15,121.5,129.69,132.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,133.39a7.54,7.54,0,0,0,4.44,3.3c2.33.56,3.13-1.78,2.19-4.13-.86-2.11-3.09-5-5.29-4.45S125.62,131.32,126.93,133.39Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,127.24c0,.65.42,1.15.85,1.12s.74-.58.69-1.24-.42-1.15-.85-1.12S140.06,126.59,140.1,127.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,126.52c.05.65.43,1.16.85,1.12s.74-.58.7-1.23-.42-1.16-.85-1.13S148.9,125.87,148.94,126.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,127.19a22.91,22.91,0,0,0,3.49,5.34,3.77,3.77,0,0,1-3.08.82Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.46,122.08a.31.31,0,0,1,.09.17.39.39,0,0,1-.28.46,3.85,3.85,0,0,1-3.44-.76.38.38,0,0,1,0-.54.4.4,0,0,1,.55,0h0a3.07,3.07,0,0,0,2.73.58A.36.36,0,0,1,143.46,122.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,124a.32.32,0,0,1-.14-.14.38.38,0,0,1,.13-.52,3.88,3.88,0,0,1,3.51-.31.38.38,0,0,1,.18.51.4.4,0,0,1-.52.18h0a3.08,3.08,0,0,0-2.77.27A.37.37,0,0,1,145.08,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.57,120.34a.4.4,0,0,1-.35-.07,3,3,0,0,0-2.69-.67.38.38,0,0,1-.22-.73,3.73,3.73,0,0,1,3.4.8.39.39,0,0,1,0,.54A.41.41,0,0,1,152.57,120.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,220h0a1.67,1.67,0,0,0-2.26-.67l-12.23,6.61-5.78-10.7a1.67,1.67,0,0,0-2.94,1.58l5.78,10.7-42.15,22.78a1.68,1.68,0,0,0-.68,2.26h0a1.68,1.68,0,0,0,2.26.68l57.33-31A1.67,1.67,0,0,0,196.16,220Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,276.18c-20-15-81.57-21-60.29-48.42l32-.3s45,23.1,47.45,47.26c2.51,25.13,7,64.7,7,64.7l-12.4,4.4S190.9,295.3,195.26,276.18Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,241.5c-.74,1.62-1.42,3.3-2,5.07,5,5.65,14.81,10,25.44,14C156.21,254.81,149,248.41,136.07,241.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.13,348.21,222,344.9a3.75,3.75,0,0,1,2.45.12c4.48,2,7.34,1.42,11.77,1.15,5.3-.34,4.11,5.36.38,6.33-6.15,1.6-5.7,1.25-11,2.62l-3.64.94-2.09-1.27-1,2-6.75,1.64a1.29,1.29,0,0,1-1.61-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,349.47c.19-.09,14.62-4.13,14.62-4.13l-2.24-11.09-16,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.77,309.82c.61-36.43-7-73.52-2.48-81.66l37.12-.52s-11.09,60.74-14,85c-3,25.24-18,90.86-18,90.86l-12,.19S111.83,336,119.77,309.82Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,405.63l11-.17a3.82,3.82,0,0,1,2.38.7c4,3,4.42,3.12,8.8,3.9,5.26.93,2.9,6.18-.95,6.24-6.36.1-5.84-.13-11.26-.05l-5.89.05-.86-1.73-1,1.73h-1.55a1.32,1.32,0,0,1-1.32-1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92,406.94c.19,0,13.85.63,13.85.63l.91-12.48-14.84.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,151.76s3.44,6.63-.51,12a21.47,21.47,0,0,1,6.55,1.36s2.79-6.75-3.36-12.79C149.05,151.61,146.8,151.76,146.8,151.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,232c17.75,1.06,38.1,1.38,50.83,0a.45.45,0,0,0,.35-.27,16.05,16.05,0,0,0,1.1-6.79c0-.36-.24-.63-.48-.62-16.8.65-33.5.61-51,0-.19,0-.38.16-.45.43a21.33,21.33,0,0,0-.75,6.63A.6.6,0,0,0,115.93,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,232c17.75,1.06,38.1,1.38,50.83,0a.45.45,0,0,0,.35-.27,16.05,16.05,0,0,0,1.1-6.79c0-.36-.24-.63-.48-.62-16.8.65-33.5.61-51,0-.19,0-.38.16-.45.43a21.33,21.33,0,0,0-.75,6.63A.6.6,0,0,0,115.93,232Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,234.73a30.69,30.69,0,0,1-3.76-.24l-.85-.11,0-.85c0-.22-.13-5.39.15-9.54l.06-.84.83-.08a48.86,48.86,0,0,1,7.59-.14l.9.06,0,.9a60.62,60.62,0,0,1-.34,9.56l-.09.59-.56.2A13,13,0,0,1,146.21,234.73Zm-2.65-2.13a20.89,20.89,0,0,0,5.35-.09,59.12,59.12,0,0,0,.26-7.63,46.76,46.76,0,0,0-5.49.1C143.52,227.85,143.54,231.08,143.56,232.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.92,224.26s-.29,5.61-.7,9.18c-.79.82-2.26.19-2.26.19s.29-5.18.64-9.25A4.88,4.88,0,0,1,126.92,224.26Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56,224.26s-.29,5.61-.7,9.18c-.79.82-2.26.19-2.26.19s.29-5.18.64-9.25A4.88,4.88,0,0,1,163.56,224.26Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,173.63c.54,7.23,5.15,8.86,5.8,8.84s5-1.82,4.46-9.05a8.86,8.86,0,0,1-5.28-1.95A7,7,0,0,1,152,173.63Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,114.43c5.14.86,7.08,3.25-4.49,4.65a91.13,91.13,0,0,1-20.16.34S141.78,114.38,151,114.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,120a139.1,139.1,0,0,1,25.94-5.26,7.55,7.55,0,0,0-2.23-5.54s5.85-1,2.94-2.75c-2-1.17-6.77-1.3-12.06-4.7-2.17,2-8.11,5.2-12.17,5.61-1,1.72-3.63,6-7.88,7.68.06,1.88,4.29,2.37,4.29,2.37A3.2,3.2,0,0,0,125.41,120Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,117.44c8.61-5.59,16.87-8,24.88-8.21a7.55,7.55,0,0,1,2.23,5.54A139.1,139.1,0,0,0,125.41,120,3.2,3.2,0,0,1,124.24,117.44Z",
    style: {
      fill: "#263238",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.51,107.7c1,4.92,4.47,5.82,4.94,5.78s3.47-1.48,2.48-6.4a7,7,0,0,1-4-1.09A4.89,4.89,0,0,1,139.51,107.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.35,123.07c1.14.16,3,8.74-2.95,9.2-5,.39-6.57-4.2-6.57-5.81C135.83,124.06,143.73,122.84,145.35,123.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,123c-.71.43.89,9.57,5,8.61,3.5-.81,2.91-5.78,2.34-7.39C154.4,121.79,148.88,122.36,147.87,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.24,123.16l3.11,5.67a4.37,4.37,0,0,1-1.71,2.7l-4.29-7.84A23.51,23.51,0,0,1,143.24,123.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,124l4.41,8a5.06,5.06,0,0,1-1.08.19,5.93,5.93,0,0,1-.72,0l-4.18-7.62A10.92,10.92,0,0,1,139.08,124Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.91,122.61l2.76,5a5.48,5.48,0,0,1-.69,2.45l-4.18-7.65A9.81,9.81,0,0,1,152.91,122.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,130.77a2.77,2.77,0,0,1-.88.59l-4.77-8.7a9.55,9.55,0,0,1,1.11-.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,177.94c.51-.22-.35-2.26-.86-2.05l-69.94,29.34a.65.65,0,0,0-.81-.26l-2.93,1.22a.67.67,0,0,0-.38.77l-9.2,3.85a15.22,15.22,0,0,0-5.38,3.84l-4.12,4.6a4.16,4.16,0,0,1-4.24,3.86l-.61,0L89.44,235.88a4.22,4.22,0,0,0-1.9,4.67,28.3,28.3,0,0,0,3.68,8.65,4.21,4.21,0,0,0,6.42.69L119,229.32a5.27,5.27,0,0,0,1.59-3.28l.26-2.64,4.62-5.16a5.25,5.25,0,0,0,9.38-4.69,1,1,0,0,0-.09-.18l1.71-.72a.67.67,0,0,0,.83.28l2.93-1.22a.67.67,0,0,0,.38-.79l40.79-17.11a.93.93,0,0,0,.49-1.22h0l22-9.23c.34-.14-.19-1.39-.53-1.24l-1.62.68-.09-1.78Zm-77.41,41.48a4.15,4.15,0,0,1-5.35-2l.61-.69.31-.13a5,5,0,0,0,.93,1,5.24,5.24,0,0,0,3.89,1.09l-.14-1.1a4.15,4.15,0,0,1-3.07-.86,4.07,4.07,0,0,1-.56-.54l5.52-2.31a1.4,1.4,0,0,0,.09.17A4.16,4.16,0,0,1,131.64,219.42Zm68.14-35.78-18.37,7.7-.65-1.54,18.93-7.94Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,177.94c.51-.22-.35-2.26-.86-2.05l-69.94,29.34a.65.65,0,0,0-.81-.26l-2.93,1.22a.67.67,0,0,0-.38.77l-9.2,3.85a15.22,15.22,0,0,0-5.38,3.84l-4.12,4.6a4.16,4.16,0,0,1-4.24,3.86l-.61,0L89.44,235.88a4.22,4.22,0,0,0-1.9,4.67,28.3,28.3,0,0,0,3.68,8.65,4.21,4.21,0,0,0,6.42.69L119,229.32a5.27,5.27,0,0,0,1.59-3.28l.26-2.64,4.62-5.16a5.25,5.25,0,0,0,9.38-4.69,1,1,0,0,0-.09-.18l1.71-.72a.67.67,0,0,0,.83.28l2.93-1.22a.67.67,0,0,0,.38-.79l40.79-17.11a.93.93,0,0,0,.49-1.22h0l22-9.23c.34-.14-.19-1.39-.53-1.24l-1.62.68-.09-1.78Zm-77.41,41.48a4.15,4.15,0,0,1-5.35-2l.61-.69.31-.13a5,5,0,0,0,.93,1,5.24,5.24,0,0,0,3.89,1.09l-.14-1.1a4.15,4.15,0,0,1-3.07-.86,4.07,4.07,0,0,1-.56-.54l5.52-2.31a1.4,1.4,0,0,0,.09.17A4.16,4.16,0,0,1,131.64,219.42Zm68.14-35.78-18.37,7.7-.65-1.54,18.93-7.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.07,189.63l-19.38,8.13a1.37,1.37,0,0,0-.76,1.72l.8,2.2a1.36,1.36,0,0,0,1.81.8l19.38-8.13a1.36,1.36,0,0,0,.75-1.72l-.79-2.2A1.36,1.36,0,0,0,182.07,189.63Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,182.05l.67-.18a4.68,4.68,0,0,1,4.75,1.44l.6.69a1.51,1.51,0,0,1-.57,2.4l-6.59,2.72a1.52,1.52,0,0,1-2-.86h0A4.69,4.69,0,0,1,194.4,182.05Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,168.25l-.5.6-.58.71L122.34,171c-.78,1-1.57,2-2.34,3.07-1.55,2.07-3,4.21-4.47,6.39s-2.79,4.41-4.15,6.65-2.56,4.56-3.75,6.89l-.88,1.76-.21.43a1,1,0,0,1-.08.14,1.44,1.44,0,0,0-.16.35,8.08,8.08,0,0,0-.46,2.33,28.15,28.15,0,0,0,.58,6.76,111.44,111.44,0,0,0,4.25,15.06l.07.19a3.75,3.75,0,0,1-6.5,3.52,61.83,61.83,0,0,1-5-7.38A57.42,57.42,0,0,1,95.36,209,34.61,34.61,0,0,1,93,199.41a20.1,20.1,0,0,1,.31-5.95,12.15,12.15,0,0,1,.44-1.64l.28-.84.2-.53.81-2.06a105.53,105.53,0,0,1,7.84-15.84c1.53-2.53,3.14-5,4.9-7.41.88-1.2,1.78-2.4,2.73-3.56.48-.59,1-1.17,1.47-1.75l.77-.88.89-1a7.5,7.5,0,0,1,11.25,9.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,156.09c2-.71-.54-2.86-.54-2.86s-10.61.33-16.91,2c-1,.91.14,2,.14,2S126.47,158.2,132.43,156.09Z",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,153s1.57,5.91,8.71,10.74c-3.12,0-7.54,3.12-7.54,3.12a17.65,17.65,0,0,1-2.69-13.42C131.19,152.75,132.27,153,132.27,153Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48,152a26.51,26.51,0,0,0,8.5,11.82,32.51,32.51,0,0,0-7.78,1.56s-3.91-3.67-2.45-11.86A6.43,6.43,0,0,1,132.48,152Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,220.41l6.21,5.35-8.24,5.36s-5-5.53-2.54-8.68Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19,224.92a5.93,5.93,0,0,1-1.69-2.2c2-2.05,6-3.74,7.79-4.2a5.22,5.22,0,0,1,1.15,3.2S106.17,222.63,104.19,224.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.54,234.25l-3.21,1.39a2.84,2.84,0,0,1-3.52-1.07l-2.22-3.45,8.24-5.36,2.16,4.69A2.85,2.85,0,0,1,116.54,234.25Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,136h0a7.18,7.18,0,0,1,6.6-.68.25.25,0,0,1,.12.34.26.26,0,0,1-.34.12,6.78,6.78,0,0,0-6.12.65.25.25,0,0,1-.34-.09A.24.24,0,0,1,141.51,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.15 173.51 138.64 173 138.59 171.91 125.11 172.42 125.15 173.51",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barricade--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "241.88 417.46 215.7 417.46 234.73 266.28 260.92 266.28 241.88 417.46",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.88 417.46 215.7 417.46 234.73 266.28 260.92 266.28 241.88 417.46",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.36 417.46 215.7 417.46 234.73 266.28 232.39 266.28 213.36 417.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.53 417.46 313.35 417.46 332.38 266.28 358.57 266.28 339.53 417.46",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.53 417.46 313.35 417.46 332.38 266.28 358.57 266.28 339.53 417.46",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311 417.46 313.35 417.46 332.38 266.28 330.04 266.28 311 417.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.12 399.47 361.08 399.47 356.94 366.56 261.98 366.56 266.12 399.47",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.12 399.47 264.57 399.47 260.42 366.56 261.98 366.56 266.12 399.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.85 368 359.63 398.03 354.02 398.03 338.95 368 355.85 368",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.38 368 344.45 398.03 323.85 398.03 308.78 368 329.38 368",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.21 368 314.28 398.03 293.67 398.03 278.61 368 299.21 368",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.05 368 284.11 398.03 267.21 398.03 263.43 368 269.05 368",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.99 417.46 378.18 417.46 359.14 266.28 332.96 266.28 351.99 417.46",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.44 333.63 368.99 344.46 361.08 281.68 334.89 281.68 341.44 333.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.99 417.46 349.65 417.46 330.62 266.28 332.96 266.28 351.99 417.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.34 417.46 280.53 417.46 261.5 266.28 235.31 266.28 254.34 417.46",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.79 333.63 271.34 344.46 263.43 281.68 237.25 281.68 243.79 333.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.34 417.46 252 417.46 232.97 266.28 235.31 266.28 254.34 417.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.33 326.66 376.32 326.66 370.08 277.11 227.09 277.11 233.33 326.66",
    style: {
      fill: "#405189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.33 326.66 230.99 326.66 224.75 277.11 227.09 277.11 233.33 326.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 279.27 374.14 324.49 365.69 324.49 343 279.27 368.44 279.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.59 279.27 351.28 324.49 320.25 324.49 297.57 279.27 328.59 279.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.16 279.27 305.85 324.49 274.82 324.49 252.13 279.27 283.16 279.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.74 279.27 260.42 324.49 234.97 324.49 229.28 279.27 237.74 279.27",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.883f35479d5f580185d98dde5be5d145.svg";
export { ForwardRef as ReactComponent };